/**
 * Etat de Téléchargement
 */
enum DownloadStateEnum {
    None = 0,
	
	InProgress = 1,

    Error = 2,

    Finished = 3,

    Downloaded = 4
};

export default DownloadStateEnum;